import { render, staticRenderFns } from "./EmergencyInvoices.vue?vue&type=template&id=9a902a88&scoped=true"
import script from "./EmergencyInvoices.vue?vue&type=script&lang=js"
export * from "./EmergencyInvoices.vue?vue&type=script&lang=js"
import style0 from "./EmergencyInvoices.vue?vue&type=style&index=0&id=9a902a88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a902a88",
  null
  
)

export default component.exports